/**
 * Block checkout (cart page, drawer, Shop Pay) until merchandise ≥ 999 TL.
 * Delivery / fee lines are ignored — they are not part of the floor.
 */
(function () {
  var DEFAULT_MIN = 999;
  var CHECKOUT_SEL =
    "[name=checkout], [href*='/checkout'], button[formaction*='/checkout'], a[formaction*='/checkout']";
  var ACCEL_SEL =
    "shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .additional-checkout-buttons";
  var HOST_SEL = [
    "[data-cart-summary]",
    "[data-bn-cart-summary]",
    ".cart-summary",
    ".cart__footer",
    ".cart-drawer__footer",
    ".bn-cart-drawer",
    "[data-bn-cart-drawer]",
    "cart-drawer",
    "#CartDrawer",
    "form[action='/cart']",
    "form[action='/checkout']",
  ].join(",");

  function cfg() {
    var root = document.querySelector("[data-bn-min-cart]");
    var raw = root && root.getAttribute("data-min-try");
    var n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_MIN;
  }

  function isFee(item) {
    var type = String(item.product_type || "").toLowerCase();
    var title = String(item.product_title || item.title || "").toLowerCase();
    return (
      type.indexOf("fee") !== -1 ||
      type.indexOf("teslimat") !== -1 ||
      title.indexOf("teslimat ücreti") !== -1 ||
      title.indexOf("standart teslimat") !== -1 ||
      title.indexOf("hızlı teslimat") !== -1
    );
  }

  function merchandiseTry(cart) {
    var kurus = 0;
    (cart.items || []).forEach(function (item) {
      if (isFee(item)) return;
      var line =
        item.final_line_price != null ? item.final_line_price : item.line_price;
      kurus += Number(line) || 0;
    });
    return kurus / 100;
  }

  function money(n) {
    return (
      Math.ceil(n).toLocaleString("tr-TR", { maximumFractionDigits: 0 }) + " TL"
    );
  }

  function message(min, total) {
    var left = Math.max(0, min - total);
    return (
      "Ödemeye geçmek için ürün tutarı (teslimat hariç) en az " +
      money(min) +
      " olmalı. Sepette " +
      money(total) +
      " var — " +
      money(left) +
      " daha ekleyin."
    );
  }

  function setFlag(ok, total, min) {
    window.__bnMinCart = {
      ok: ok,
      merchandise: total,
      minTry: min,
      refresh: refresh,
    };
    document.documentElement.classList.toggle("bn-min-cart-blocked", !ok);
    document.documentElement.classList.toggle("bn-min-cart-ok", ok);
  }

  function disableEl(el, on) {
    if (!el) return;
    if (on) {
      el.setAttribute("disabled", "disabled");
      el.setAttribute("aria-disabled", "true");
      el.setAttribute("tabindex", "-1");
      el.style.pointerEvents = "none";
    } else {
      el.removeAttribute("disabled");
      el.removeAttribute("aria-disabled");
      el.removeAttribute("tabindex");
      el.style.pointerEvents = "";
    }
  }

  function applyButtons(ok) {
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (el) {
      disableEl(el, !ok);
    });
    document.querySelectorAll(ACCEL_SEL).forEach(function (el) {
      el.hidden = !ok;
      el.setAttribute("aria-hidden", String(!ok));
      el.style.display = ok ? "" : "none";
    });
  }

  function applyBanners(ok, min, total, itemCount) {
    var hosts = document.querySelectorAll(HOST_SEL);
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      var parent = btn.closest("form, .cart-summary, [data-cart-summary], aside, footer, section") || btn.parentElement;
      if (parent && !Array.prototype.includes.call(hosts, parent)) {
        hosts = Array.prototype.slice.call(hosts).concat([parent]);
      }
    });
    if (!hosts.length && !ok && itemCount > 0) {
      var fallback = document.querySelector("main") || document.body;
      if (fallback) hosts = [fallback];
    }
    document.querySelectorAll("[data-bn-min-cart-msg]").forEach(function (el) {
      var keep = false;
      hosts.forEach(function (h) {
        if (h.contains(el)) keep = true;
      });
      if (!keep) el.remove();
    });
    if (ok || itemCount === 0) {
      document.querySelectorAll("[data-bn-min-cart-msg]").forEach(function (el) {
        el.remove();
      });
      return;
    }
    var text = message(min, total);
    hosts.forEach(function (host) {
      if (host.querySelector && host.querySelector(".bn-cart-alert")) return;
      var el = host.querySelector("[data-bn-min-cart-msg]");
      if (!el) {
        el = document.createElement("p");
        el.setAttribute("data-bn-min-cart-msg", "");
        el.className = "bn-min-cart-msg";
        el.setAttribute("role", "status");
        host.insertBefore(el, host.firstChild);
      }
      el.textContent = text;
    });
  }

  function apply(cart) {
    var min = cfg();
    var total = merchandiseTry(cart || { items: [] });
    var itemCount = Number((cart && cart.item_count) || 0);
    var ok = itemCount === 0 || total >= min;
    setFlag(ok, total, min);
    applyButtons(ok);
    applyBanners(ok, min, total, itemCount);
    return ok;
  }

  function refresh() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .then(apply)
      .catch(function () {
        return window.__bnMinCart ? window.__bnMinCart.ok : true;
      });
  }

  function isCheckoutUrl(href) {
    if (!href) return false;
    try {
      var u = new URL(href, window.location.origin);
      return u.pathname.indexOf("/checkout") !== -1;
    } catch {
      return String(href).indexOf("/checkout") !== -1;
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!window.__bnMinCart || window.__bnMinCart.ok !== false) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var hit = t.closest(CHECKOUT_SEL);
      if (hit || (t.closest("a") && isCheckoutUrl(t.closest("a").href))) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (e) {
      if (!window.__bnMinCart || window.__bnMinCart.ok !== false) return;
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (form.querySelector("[name=checkout]") || isCheckoutUrl(action)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true,
  );

  ["cart:updated", "cart:change", "bn:cart:updated", "scd:added"].forEach(
    function (name) {
      document.addEventListener(name, function () {
        refresh();
      });
    },
  );

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    // Called with `window` and never allowed to reject on our account: the
    // theme's own cart calls go through here, and a throw would take the
    // drawer's remove and quantity buttons down with it.
    window.fetch = function () {
      var out = nativeFetch.apply(window, arguments);
      try {
        var input = arguments[0];
        var url = typeof input === "string" ? input : input && input.url;
        if (url && /\/cart\/(add|change|update|clear)/.test(String(url))) {
          out.then(function () {
            setTimeout(refresh, 50);
          }, function () {});
        }
      } catch {
        /* never interfere with the caller's request */
      }
      return out;
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }

  window.__bnMinCart = {
    ok: true,
    merchandise: 0,
    minTry: cfg(),
    refresh: refresh,
  };
})();
